"use strict";
import { extendTheme } from '@chakra-ui/react';
import colors from './colors.mjs';
import components from './components.mjs';

const systemFontStack = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";';
const ecoinventTheme = extendTheme({
  colors,
  components,
  config: {
    initialColorMode: "light",
    useSystemColorMode: false
  }
});

export { ecoinventTheme, systemFontStack };
